import {defineElement, html, TemplateElement, when} from '@webtides/element-js';

/**
 * @property {string} sectionHeadline
 * @property {string} headline
 * @property {string} currency
 * @property {string} accountType
 * @property {string} limit
 * @property {string} rate
 * @property {string} legal
 */
export default class DataTable extends TemplateElement {


    properties() {
        return {
            sectionHeadline:'',
            headline:'',
            currency:'',
            accountType:'',
            limit:'',
            rate:'',
            rows:[],
            legal:'',
        };
    }

    template() {
        return html`
            ${when(this.sectionHeadline, html` <h2 class="text-xl font-medium text-green-medium mb-24">${this.sectionHeadline}</h2> `)}
            <div class="border-[1px] border-solid border-gray-20 rounded-md px-20 py-12">
                <table class="w-full table-fixed border-collapse">

                    <tr>
                        <td class="w-1/2 text-left align-top">
                            <span class="block">${this.headline}</span>
                            <span class="block">${this.currency}</span>
                        </td>
                        <td class="w-1/2 text-right align-top"></td>
                    </tr>

                    <tr>
                        <td class="w-1/2 text-left align-top  py-6">
                            <span class="block text-sm text-green-light">${this.accountType}</span>
                            <span class="block text-sm text-green-light">${this.rate}</span>
                        </td>
                        <td class="w-1/2 text-right text-sm text-green-light align-top  py-6">
                            ${this.limit}
                        </td>
                    </tr>

                    ${this.rows.map(
                        (row) => html`
                            <tr style="border-top:1px solid #ccc;">
                                <td class="w-1/2 text-left align-top py-6">
                                    <span class="block text-sm text-green-medium font-medium">${row.accountType}</span>
                                    <span class="block text-sm text-green-medium lining-nums tabular-nums">${row.rate}</span>
                                </td>
                                <td class="w-1/2 text-right text-sm  py-6 text-green-medium align-top">
                                    <span class="block lining-nums tabular-nums" >${row.limit}</span>
                                    <span class="block lining-nums tabular-nums">${row.limitAbove}</span>
                                </td>
                            </tr>
                        `,
                    )}


                </table>
            </div>
            <p class="text-xs text-green-medium pt-24">${this.legal}</p>
        `;
    }

}

defineElement('mb-e-banking-data-table', DataTable);
